import { useFormikContractHelpers } from 'hooks';
import { ITemplatesLightListItem } from 'services/templates/types';
import './ContractSideMenuTemplateListItem.scss';

export interface IContractSideMenuTemplateListItemProps {
  template: ITemplatesLightListItem;
  onAddCustomTemplate?: (id: string) => void;
}

const ContractSideMenuTemplateListItem = ({
  template,
  onAddCustomTemplate,
}: IContractSideMenuTemplateListItemProps) => {
  const { setFieldValue, values } = useFormikContractHelpers();

  const onClick = () =>
    onAddCustomTemplate
      ? onAddCustomTemplate(template.id)
      : setFieldValue('sideMenu.customTemplate.selectedId', template.id);

  return (
    <div onClick={onClick} className={'contract-custom-template-item'}>
      <div className='contract-custom-template-text'>
        {template.title ?? template.id}
      </div>
    </div>
  );
};

export default ContractSideMenuTemplateListItem;
